import { render } from "./PrecoFiltro.vue?vue&type=template&id=650f25f8"
import script from "./PrecoFiltro.vue?vue&type=script&lang=js"
export * from "./PrecoFiltro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__